/**
 * SEO for the verification-email-sent route (`/auth/verification-email-sent`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

export type VerificationEmailSentPageSeoLoaderInput = Record<string, never>

export function verificationEmailSentPageHeadFromLoaderData(
  _loaderData?: VerificationEmailSentPageSeoLoaderInput | null | undefined
) {
  const pageUrl = absoluteUrlForPath('/auth/verification-email-sent')
  const description =
    'Open the Spicy Friends verification email to confirm your address and unlock messaging. Resend after cooldown; add us to safe senders if filtered.'

  return seo({
    title: `Verify your email address | ${env.VITE_APP_NAME}`,
    description,
    url: pageUrl,
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
  })
}
